import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import { errorMessage } from "helpers/utils";
import {
  all,
  call,
  put,
  race,
  select,
  take,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import DashboardService from "services/DashboardService";
import {
  BU_STORE_HEADER,
  BU_TENANT_HEADER,
  TENANT_CODE_HEADER,
} from "store/auth/login/actionTypes";
//Include Both Helper File with needed methods
import {
  getMonthlyData,
  getWeeklyData,
  getYearlyData,
} from "../../helpers/fakebackend_helper";
import {
  apiFail,
  apiSuccess,
  getChartsDataMessageStatusFail,
  getChartsDataMessageStatusSuccess,
  getListBUChildFail,
  getListBUChildSuccess,
  getListBUStoreHeaderFail,
  getListBUStoreHeaderSuccess,
  getListBUTenantHeaderFail,
  getListBUTenantHeaderSuccess,
  getListTenantHeaderFail,
  getListTenantHeaderSuccess,
  setBUStoreHeaderFail,
  setBUStoreHeaderScope,
  setBUStoreHeaderSuccess,
} from "./actions";
// Crypto Redux States
import {
  GET_CHARTS_DATA,
  GET_CHARTS_DATA_MESSAGE_STATUS,
  GET_LIST_BU_CHILD,
  GET_LIST_BU_STORE_HEADER,
  GET_LIST_BU_TENANT_HEADER,
  GET_LIST_TENANT_HEADER,
  SET_BU_STORE_HEADER,
  SET_BU_TENANT_HEADER,
  SET_TENANT_CODE_HEADER,
} from "./actionTypes";
function* fetchGetChartsDataMessageStatus({ tenantCode, year }) {
  try {
    const responseStatus = yield call(DashboardService.getChartPie, tenantCode);
    // const responseSummary = yield call(
    //   DashboardService.getChartSummary,
    //   "total",
    //   tenantCode
    // );
    const responseInvoice = yield call(
      DashboardService.getChartInvoice,
      "inyear",
      tenantCode
    );
    const chartsMLTDiep = {
      series: responseStatus.data,
      labels: responseStatus.data,
    };
    // const chartMLTDiepInYear = responseSummary.data;
    const chartMLTDiepInYear = null;
    const totalMessage = responseInvoice.data;
    yield put(
      getChartsDataMessageStatusSuccess(
        responseStatus,
        chartsMLTDiep,
        chartMLTDiepInYear,
        totalMessage
      )
    );
  } catch (error) {
    yield put(getChartsDataMessageStatusFail(errorMessage(error)));
  }
}
function* getChartsData({ payload: periodType }) {
  try {
    var response;
    if (periodType == "monthly") {
      response = yield call(getWeeklyData, periodType);
    }
    if (periodType == "yearly") {
      response = yield call(getYearlyData, periodType);
    }
    if (periodType == "weekly") {
      response = yield call(getMonthlyData, periodType);
    }

    yield put(apiSuccess(GET_CHARTS_DATA, response));
  } catch (error) {
    yield put(apiFail(GET_CHARTS_DATA, errorMessage(error)));
  }
}

export function* watchGetChartsData() {
  yield takeEvery(GET_CHARTS_DATA, getChartsData);
}

function* fetchSetTenantCodeHeader({ tenantCodeHeader }) {
  localStorage.setItem(TENANT_CODE_HEADER, tenantCodeHeader);
}

function* fetchSetBUTenantHeader({ buTenantHeader }) {
  localStorage.setItem(BU_TENANT_HEADER, buTenantHeader);
  //   localStorage.removeItem(BU_STORE_HEADER);
  //   try {
  //     // Call api
  //     const response = yield call(
  //       DashboardService.getListBUMethodSign,
  //       buTenantHeader,
  //       buTenantHeader
  //     );
  //     if (response && response.items) {
  //       yield put(setBUTenantHeaderSuccess(response.items));
  //     } else {
  //       yield put(setBUTenantHeaderFail("Lỗi"));
  //     }
  //   } catch (error) {
  //     yield put(setBUTenantHeaderFail(error));
  //   }
}

function* fetchGetListTenantHeader() {
  try {
    // Call api
    const response = yield call(DashboardService.getListTenantHeader);
    let listTenant = [];
    if (response && response.data) {
      listTenant = response.data.map(item => {
        return {
          label: item.tenantName,
          value: item.tenantCode,
        };
      });
    }
    yield put(getListTenantHeaderSuccess(listTenant));
  } catch (error) {
    yield put(getListTenantHeaderFail(errorMessage(error)));
  }
}

function* fetchGetListBuTenantHeader() {
  try {
    // Call api
    const response = yield call(DashboardService.getListBUTenant);
    let listBU = [];
    if (response && response.items) {
      listBU = response.items.map(item => {
        return {
          ...item,
          itemBU: item,
          label: item.code + " - " + item.ten,
          value: item.id,
          code: item.code,
          is_release: item.is_release,
          parent_id: item.parent_id,
        };
      });
    }
    if (listBU.length > 1) {
      listBU.unshift({
        label: `Tất cả (${listBU.length})`,
        value: ALL_BU,
        code: ALL_BU,
      });
    }
    yield put(getListBUTenantHeaderSuccess(listBU));
  } catch (error) {
    yield put(getListBUTenantHeaderFail(errorMessage(error)));
  }
}

function* fetchGetListBuChild() {
  try {
    // Call api
    const response = yield call(DashboardService.getListBUChild);
    let listBU = [];
    if (response && response.items) {
      listBU = response.items.map(item => {
        return {
          ...item,
          itemBU: item,
          label: item.code + " - " + item.ten,
          value: item.id,
          code: item.code,
        };
      });
    }
    yield put(getListBUChildSuccess(listBU));
  } catch (error) {
    yield put(getListBUChildFail(errorMessage(error)));
  }
}

function* fetchGetListBuStoreHeader({ parentId }) {
  try {
    if (parentId === ALL_BU) {
      yield put(getListBUStoreHeaderSuccess([]));
      return;
    }
    // Call api
    const { listBuOfTenant } = yield select(state => state.Dashboard);
    const listBuParentId = listBuOfTenant
      .filter(item => item.id)
      .map(item => item.id);
    const response = yield call(
      DashboardService.getListBUStore,
      parentId,
      listBuParentId
    );
    let listBUStore = [];
    if (response && response.items) {
      listBUStore = response.items.map(item => {
        return {
          ...item,
          label: item.code + " - " + item.ten,
          value: item.code,
          hdbhang: item.hdbhang,
          hdbhdtqgia: item.hdbhdtqgia,
          hdbtscong: item.hdbtscong,
          hdgtgt: item.hdgtgt,
          hdkhac: item.hdkhac,
          invoice_type: item.invoice_type,
          is_release: item.is_release,
          parent_id: item.parent_id,
        };
      });
      if (listBUStore.length > 1) {
        listBUStore.unshift({
          label: `Tất cả (${listBUStore.length})`,
          value: ALL_STORE,
        });
      }
    }
    // if(listBUStore.length===0){

    // }
    yield put(getListBUStoreHeaderSuccess(listBUStore));
  } catch (error) {
    yield put(getListBUStoreHeaderFail(errorMessage(error)));
  }
}

// User đổi chi nhánh khác trong lúc đang lấy cấu hình => huỷ luôn lần lấy đang chạy
// (redux-saga cancel task sẽ abort các request đang gọi dở), tránh kết quả cũ về sau
// ghi đè/làm hỏng lựa chọn mới
function* fetchSetBUStoreHeader(action) {
  yield race({
    task: call(setBUStoreHeaderTask, action),
    cancel: take(GET_LIST_BU_STORE_HEADER),
  });
}

function* setBUStoreHeaderTask({ bUStoreHeader, shopCode }) {
  if (bUStoreHeader === ALL_BU) {
    const finalBuInfo = {
      code: ALL_BU,
      label: "Tất cả",
      value: ALL_BU,
    };
    yield put(setBUStoreHeaderScope(bUStoreHeader, finalBuInfo, null, null));
    yield put(setBUStoreHeaderSuccess([], []));
    return;
  }
  localStorage.setItem(BU_STORE_HEADER, shopCode);
  try {
    // Get info final level select store - chỉ đọc từ state, không cần api
    const { listBuStore, listBuOfTenant } = yield select(
      state => state.Dashboard
    );
    var value = null;
    let finalBuInfo = null;
    let finalBuReleaseInfo = null;
    if (listBuStore && listBuStore.length > 0) {
      value = listBuStore.find(item => item.value === shopCode);
      finalBuInfo = value;
    } else {
      value = listBuOfTenant.find(item => item.code === shopCode);
      finalBuInfo = value && value.itemBU;
    }
    // Không tìm thấy: danh sách đã đổi vì user chọn chi nhánh/đơn vị khác giữa chừng,
    // kết quả này là của lựa chọn cũ nên bỏ qua
    if (!finalBuInfo) {
      yield put(setBUStoreHeaderFail("Chi nhánh/đơn vị đã thay đổi"));
      return;
    }
    //Nếu có sẽ lấy thông tin phát hành theo nó
    if (finalBuInfo.is_release) {
      finalBuReleaseInfo = finalBuInfo;
    } else {
      // Nếu có cha thì lấy theo cha, k có cha  thì lấy theo nó
      if (finalBuInfo.parent_id) {
        finalBuReleaseInfo = listBuOfTenant.find(
          item => item.id === finalBuInfo.parent_id
        );
      } else {
        finalBuReleaseInfo = finalBuInfo;
      }
    }
    // Nếu chọn tất cả đơn vị
    let finalListBuCode = [];
    if (shopCode === ALL_STORE) {
      const listAllStore = listBuStore
        .filter(item => item.value !== ALL_STORE)
        .map(item => item.code);
      finalListBuCode = listAllStore;
    } else {
      finalListBuCode = [shopCode];
    }
    // Phạm vi đã xác định xong -> bắn ra ngay để các trang load danh sách,
    // không phải đợi 2 api cấu hình chữ ký bên dưới
    yield put(
      setBUStoreHeaderScope(
        shopCode,
        finalBuInfo,
        finalBuReleaseInfo,
        finalListBuCode
      )
    );

    // 2 api cấu hình chữ ký chạy song song với nhau và song song với danh sách
    const [response, responseInfo] = yield all([
      call(DashboardService.getListBUMethodSign, bUStoreHeader, shopCode),
      call(DashboardService.getListBUMethodSignInfo, shopCode),
    ]);
    if (response && response.items) {
      yield put(setBUStoreHeaderSuccess(response.items, responseInfo.items));
    } else {
      yield put(setBUStoreHeaderFail("Lỗi"));
    }
  } catch (error) {
    yield put(setBUStoreHeaderFail(errorMessage(error)));
  }
}

function* dashboardSaga() {
  //   yield all([fork(watchGetChartsData)]);
  yield takeEvery(
    GET_CHARTS_DATA_MESSAGE_STATUS,
    fetchGetChartsDataMessageStatus
  );
  yield takeEvery(SET_TENANT_CODE_HEADER, fetchSetTenantCodeHeader);
  yield takeEvery(SET_BU_TENANT_HEADER, fetchSetBUTenantHeader);
  // takeLatest: chỉ lấy kết quả của chi nhánh/đơn vị chọn sau cùng,
  // request của lần chọn trước bị huỷ (xem CANCEL trong DashboardService)
  yield takeLatest(SET_BU_STORE_HEADER, fetchSetBUStoreHeader);

  yield takeEvery(GET_LIST_TENANT_HEADER, fetchGetListTenantHeader);
  yield takeEvery(GET_LIST_BU_TENANT_HEADER, fetchGetListBuTenantHeader);
  yield takeEvery(GET_LIST_BU_CHILD, fetchGetListBuChild);
  yield takeLatest(GET_LIST_BU_STORE_HEADER, fetchGetListBuStoreHeader);
}

export default dashboardSaga;
